<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="page-box">
      <div class="secure-block"
           id="one">
        <h3 class="rescue-bigtitle">新药新技术</h3>
        <h4 class="rescue-title"
            id="one">为什么出国看病？</h4>
        <div class="inner-main">
          <div class="why-go-out">
            <div v-for="(item, index) in textList"
                 :key="index">
              <h4>
                <span>
                  <img :src="item.icon"
                       alt="">
                </span>
                <span>{{item.title}}</span>
              </h4>
              <div>
                <p class="content_class" v-for="(content, key) in item.content"
                   :key="key">
                  {{content}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <h4 class="rescue-title"
            id="two"
            style="margin-top:67px; margin-bottom: 59px;">为什么找威马捷？ </h4>
        <img class="inner-img"
             :src="reason"
             style="height:401px;" />
        <h4 class="rescue-title"
            id="three"
            style="margin-top:93px; margin-bottom:50px;">国际比较 </h4>
        <img class="inner-img"
             :src="compare"
             @click="modal11 = true"
             style="padding:0 16px; margin-bottom:42px;" />

        <img class="inner-img"
             :src="compare_countries"
             style="width:832px; margin: 0 auto; display:block; margin-bottom:100px;" />
        <h4 class="rescue-title"
            id="four">看病流程 </h4>
        <img class="inner-img"
             :src="index_steps"
             style="width:829px; margin: 0 auto; display:block; margin-bottom:40px;" />
      </div>

      <Modal v-model="modal11" fullscreen title=" " style="height: 100%;" footer-hide>
        <img :src="compare" alt="" style="width: 100%;" />
      </Modal>
      <div class="main"
           style="width:980px;">

        <h5 class="secure-title title01"
            id="hospital">合作医院
          <router-link to="/hospitalList/fwlx/0" target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="secure-hospital">
          <router-link v-for="(hos, index) in hospitals"
                       :to="'/hospitalInfo/' + hos.id"
                       target="_blank"
                       :key="index">
            <img class="hospital-img"
                 :src="baseURL + hos.hospital_img"
                 alt="">
            <div class="hospital-content">
              <h6 class="hospital-name"
                  v-html="hos.name"></h6>
              <p class="hospital-info">{{hos.easy_brief}}</p>
            </div>
          </router-link>
        </div>
        <h5 class="secure-title title02"
            id="cases"
            style="padding-top:70px;">服务案例
          <router-link to="/successCase/1" target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="fw-bg">
          <div class="medicine-case"
               v-for="(c,index) in cases"
               :key="index">
            <router-link target="_blank" :to="{name: 'successCaseDetail',params:{ id: c.id} }">
              <div class="case-info">
                <h5 class="case-info_text">{{c.title}}</h5>
                <p class="case-ill">
                  <span>疾病：{{c.disease_name}} </span>
                  <span class="b">{{c.alias}} <br/>{{c.age}} 岁</span>
                </p>
                <!-- <p class="case-topic">摘要： {{c.desc}}</p> -->
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reason from '@/assets/images/medicine/index-reason.jpg'
import compare from "@/assets/images/medicine/international_compare.jpg"
import compare_countries from "@/assets/images/medicine/compare_in_countries.jpg"
import index_steps from "@/assets/images/medicine/index-steps.png"

import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as cases from '@/api/success'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      reason,
      compare,
      compare_countries,
      index_steps,
      countries: [],
      cases: [],
      hospitals: [],
      modal11: false,
      anchor: [
        { title: '为什么出国看病', id: 'one' },
        { title: '为什么找威马捷', id: 'two' },
        { title: '国际比较', id: 'three' },
        { title: '看病流程', id: 'four' },
        { title: '合作医院', id: 'hospital' },
        { title: '服务案例', id: 'cases' },
      ],
      textList: [
        {
          title: "新药",
          icon: require('../assets/images/medicine/icon01.png'),
          content: [
            '国务院新闻办公室于2018年6月22日举行的国务院政策例行吹风会上，国家药品监督管理局局长焦红表示：近十年来，在美国、欧盟、日本上市的新药有415个，其中，仅有76个在中国上市，有201个处于我国的临床试验和申报阶段。说明有339个新药，患者在国内是无法使用的，只有到国外才有可能使用。以2019年来看，进口药在中国首次获批的时间，比国际（美国、欧盟、日本）获批时间平均晚5.55年。尽管近几年中国在缩短新药上市时间差上做了很多努力，但是还是存在一定的差距。'
          ]
        },
        {
          title: "新技术",
          icon: require('../assets/images/medicine/icon02.png'),
          content: [
            '美国、日本、欧盟作为世界三大医疗国家和区域，在很多医疗领域处于世界前沿。特别是日本在肿瘤治疗、康复医疗、再生医疗等领域技术先进。',
            '美国首先开展了质子线医疗应用的研究，但是被日本后来追上得以推广，目前主要的设备制造商为比利时的IBA，日本的日立、东芝、住友。',
            '同时，日本又将重离子线技术成功运用于医疗领域，目前主要的重离子线设备制造商为日本的日立和东芝。'
          ]
        },
        {
          title: "个性化医疗",
          icon: require('../assets/images/medicine/icon03.png'),
          content: [
            '医疗既要标准化，还要根据每位患者的实际情况个性化。日本、德国、美国等发达国家的权威医院一般会在标准化治疗的基础上，根据患者的病情适当调整。需要多学科协作时，也无需患者提出，医生会根据病情需求内部协调相关科室和专家制定治疗方案。'
          ]
        },
        {
          title: "人性化服务",
          icon: require('../assets/images/medicine/icon04.png'),
          content: [
            '海外的大多数权威医院实行完全预约制，患者无需把大部分时间花费在无用的等待上。在医院，会有工作人员亲切并准确的告诉患者现在需要到哪里、找谁、干什么，下一步需要干什么。在等待、诊疗、检查、治疗等各个环节，都会以患者为中心，让患者很有尊严的接受服务。'
          ]
        },

      ]

    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getSuccessList();
  },
  methods: {
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 1,
          //出国看病 3
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          // console.log(res.data.data)
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getSuccessList () {
      try {
        let data = {
          page: 1,
          id: 0,
          disease_id: 0,
          type_id: 1
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less">
img {
  backface-visibility:hidden;
  -webkit-backface-visibility:hidden;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  box-sizing: border-box;
  padding: 30px;
  padding-bottom: 0;
  margin: 20px auto 0px;
}
.secure-title {
  font-size: 24px;
  color: #000;
  line-height: 28px;
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 28px auto;
  margin-bottom: 40px;
  a {
    float: right;
    color: #333130;
  }
}
.title01 {
  // background-image: url("../assets/images/home/yy-icon.png");
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;

  a {
    font-size: 24px;
  }
}
.title02 {
  background: url('../assets/images/home/fwal-icon.png') no-repeat 0 70px;
  background-size: 28px 28px;
}
.secure-reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.secure-note {
  font-size: 16px;
  color: #000;
  line-height: 32px;
}
.secure-specials {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 72px;
  p {
    width: 234px;
    height: 65px;
    background: #ae1e10;
    color: #fff;
    font-size: 24px;
    line-height: 65px;
    text-align: center;
  }
}
#hospital {
  padding-top: 107px;
}
.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;
  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    // margin-right: 20px;
    transition: 0.5s all;
    margin-right: 37px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 0 10px #d1d1d1;
    }
  }
  .hospital-img {
    width: 300px;
    height: 220px;
    margin: 0 !important;
  }
  .hospital-content {
    padding: 20px 24px 35px;
    height: 200px;
    .hospital-name {
      min-height: 47px;
      font-size: 20px;
      color: #333130;
      line-height: 26px;
      margin-bottom: 15px;
    }
    .hospital-info {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      color: #9b9898;
      font-size: 16px;
      line-height: 32px;
    }
  }
}
.medicine-case:last-child {
  margin-bottom: 133px;
}

.fw-bg {
  background: url(../assets/images/fw-bg.png) no-repeat left top #fff;
}

.medicine-case {
  width: 100%;
  border: 1px solid #ececec;
  padding: 34px 54px 34px 27px;
  .case-img {
    width: 237px;
    height: 177px;
    margin-right: 34px;
  }
  .case-info_text {
    width:500px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;

  }
  .case-info {
    display: block;
    // width: 610px;
    // vertical-align: top;
    h5 {
      font-size: 20px;
      color: #373737;
      font-weight: normal;
      line-height: 26px;
      margin-bottom: 10px;
      p {
        display: inline-block;
        font-size: 16px;
      }
    }
    .case-ill {
      font-size: 18px;
      line-height: 22px;
      color: #cf1300;
      font-weight: bold;
      span {
        width: 200px;
        display: inline-block;
      }
      .b {
        margin-left: 350px;
        font-weight: 400;
        color: #373737;
      }
      // background: url("../assets/images/medicine/line.jpg") repeat-x bottom;
      // padding-bottom: 16px;
      // margin-bottom: 18px;
    }
    .case-topic {
      font-size: 14px;
      color: #585858;
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
</style>
<style lang="less" scoped>
.inner-img {
  width: 100%;
}
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}

.qualify {
  padding: 50px 0 60px;
}
.qualify-title {
  font-size: 24px;
  color: #000;
  text-align: center;
  margin: 40px 0;
}
.secure-zizhi {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 66px;
  .qualifications {
    img {
      width: auto;
      height: 226px;
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      color: #ae1e10;
      line-height: 20px;
      text-align: center;
    }
  }
}
.user-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .secure-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 110px;
    border: 1px solid #dcdcdc;
    background: #fff;
    img {
      width: 60px;
      height: 60px;
      margin-right: 18px;
    }
    p {
      font-size: 28px;
      color: #ae1e10;
    }
  }
}

.why-go-out {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  div {
    width: 450px;
    h4 {
      font-size: 20px;
      color: #000;
      line-height: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background-color: #e9ebf3;
      padding: 20px 26px;
      span:nth-of-type(1) {
        width: 23px;
        height: 23px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
      }
      span:nth-of-type(2) {
        margin-left: 14px;
      }
    }
    div {
      border: 1px solid #e9ebf3;
      padding: 22px 16px 0 18px;
      line-height: 30px;
      height: 313px;
      margin-bottom: 31px;
      p {
        font-size: 16px;
        color: #33312f;
      }
    }
  }
}
  .content_class {
    text-align: justify;
    -ms-text-align-last: justify;
    -moz-text-align-last: justify;
    text-align-last: start;
    word-break: break-all;
    text-justify: distribute;
  }
  ::v-deep .ivu-modal {
    top: 0!important;
  }
  ::v-deep .ivu-modal-fullscreen .ivu-modal-body {
    height: 800px;
  }
</style>
